export const authChannelName = "agent-showcase-auth";

export function notifySessionChanged() {
  if (typeof BroadcastChannel === "undefined") return;
  const channel = new BroadcastChannel(authChannelName);
  channel.postMessage("session-changed");
  channel.close();
}
